import { render, staticRenderFns } from "./RevisionItem.vue?vue&type=template&id=1b06230b&"
import script from "./RevisionItem.vue?vue&type=script&lang=ts&"
export * from "./RevisionItem.vue?vue&type=script&lang=ts&"
import style0 from "./RevisionItem.vue?vue&type=style&index=0&id=1b06230b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports